import { data_from_server_post } from '@/shared/http/client';

export const RANKED_REVIEW_QUEUE_K = 30;

export function rankedReviewQueueRoute(rankScoreInitialized) {
    return rankScoreInitialized ? 'get-top-ranked-examples' : 'get-similar-validated-examples';
}

export function recordIdsFromRankedExamples(response) {
    return (response?.examples || [])
        .map((example) => example.record_id || example.id)
        .filter(Boolean);
}

/** Ranked review queue used by Improvement Mode View to filter the dataset table. */
export function fetchRankedReviewQueue({
    dataset,
    label,
    clientId,
    isBenchmark,
    llmUsecaseId,
    rankScoreInitialized,
    onSuccess,
    onError,
}) {
    data_from_server_post(
        rankedReviewQueueRoute(rankScoreInitialized),
        {
            dataset,
            label,
            client_id: clientId,
            is_benchmark: isBenchmark,
            k: RANKED_REVIEW_QUEUE_K,
            llm_usecase_id: llmUsecaseId,
        },
        onSuccess,
        onError,
    );
}
